import WebSocketWrapper from '@/utils/web-socket/websocket-wrapper';

export const bikeWbConnectAPI = {
  data () {
    return {
      ws: '',
      timeInterval: null
    };
  },
  mounted () {
    const wsUrl = 'ws://127.0.0.1:58000/';
    const apiCustomer = 'BR';
    const apiKey =
      '30f239bf561b7e33b94bf6370926341c83efa84102be92027601a74a2ae1160b';
    this.ws = new WebSocketWrapper(wsUrl, apiCustomer, apiKey);
    this.destroyFlag = false;

    /**
     * connect 連結websocket，建立通道
     */
    this.ws.connect();

    this.ws.onConnected = data => {
      this.$store.dispatch('bikeConnect/getMGopen', false);
      if (this.getBikeFlag) {
        this.ws.ChangeBike();
      } else {
        this.ws.CheckComport();
      }
    };

    this.ws.onDisconnected = data => {
      this.$store.dispatch('bikeConnect/getMGopen', true);
    };

    /**
     * CheckComponrt 檢查是否接上Dongle
     */
    this.ws.onCheckComport = data => {
      const currectPath = this.$route.path;
      console.log('onCheckComport data:%s', JSON.stringify(data));
      if (data.Status === 1000 || data.FwVer === '--') {
        if (currectPath !== '/changebike') {
          this.$store.dispatch('bikeConnect/setDGFWVer', data.FwVer);
          this.$store.dispatch('bikeConnect/setDGPartNumber',data.PartNO);
          // 需判斷dongle版本是否正確所以更改為check完or強制更新dongle完再checkpower
          this.funcCheckDGUpdate();
        } else {
          this.ws.CheckPower();
        }
      } else {
        console.log(data);
        this.$router.push({ name: 'ConnectFailed', params: { fail: 'ComportError' } });
      }
    };

    this.ws.onUpgradeDongle = data => {
      switch (data.Status) {
        case 1000:
          this.funcChangeUpgradeStatus('S', '', 100);
          this.ws.CheckComport();
          break;
        case 1200:
          this.funcChangeUpgradeStatus('P', data.Message);
          break;
        case 1201:
          let stateStyle = 'P';
          if (data.Progress === 100) {
            stateStyle = 'S';
          }
          this.funcChangeUpgradeStatus(stateStyle, data.Message, data.Progress);
          break;
        case 1001:
          let updateMsg =
            '[' +
            data.ErrorCode +
            ']' +
            this.$t('connectBike.dongleUpdateFail');
          this.funcChangeUpgradeStatus('F', updateMsg);
          this.isDGupdateFailed = true;
          break;
      }
    };

    /**
     * CheckPower / onCheckPower 檢查是否接上開啟電源
     */
    this.ws.onCheckPower = data => {
      if (data.Status === 1000) {
        this.ws.ReadPara(); // only connect
      } else {
        this.$router.push({ name: 'ConnectFailed', params: { fail: 'PowerError' } });
      }
    };

    // only connect page
    this.ws.onReadPara = data => {
      if (data.Status === 1000) {
        this.ws.GetBikeId();
      } else {
        this.$router.push({ name: 'ConnectFailed', params: { fail: 'ReadInfoError' } });
      }
    };
    this.ws.onGetBikeId = data => {
      // console.log('onGetBikeId', data)
      if (data.Status === 1000) {
        this.bikeId = data.BikeId;
        this.$store.dispatch('bikeConnect/setBikeId', data.BikeId);
        this.ws.GetDeviceInfo();
      } else {
        console.log(data);
        this.$router.push({ name: 'ConnectFailed', params: { fail: 'ReadInfoError' } });
      }
    };
    this.ws.onWriteBikeId = data => {
      // console.log('onWriteBikeId', data)
      if (data.Status === 1000) {
        this.ws.GetSystemInfo();
        this.$store.dispatch('bikeConnect/setBikeId', this.newBikeId);
      } else this.$router.push({ name: 'ConnectFailed', params: { fail: 'WriteInfoError' } });
    };
    this.ws.onWriteFrameNo = data => {
      console.log('onWriteFrameNo', data);
      if (data.Status === 1000) {
        this.funcWriteBikeId();
      } else {
        this.$router.push({ name: 'ConnectFailed', params: { fail: 'WriteInfoError' } });
      }
    };
    this.ws.onGetDeviceInfo = data => {
      // console.log('onGetDeviceInfo ->', data);
      if (data.Status === 1000) {
        this.requestData = data.RequestData;
        this.$store.dispatch('bikeConnect/getDeviceInfo', this.requestData);
        // 判斷是否有display
        if (this.requestData.DisplayPN !== '') {
          this.$store.dispatch('diagnosis/addIsDisp', false);
        } else {
          this.$store.dispatch('diagnosis/addIsDisp', true);
        }
        // call api 確認是否為 品牌客戶的車子
        this.funcGetPartBrandPrefixAPI(this.requestData.ConsolePN);
      } else {
        this.$router.push({ name: 'ConnectFailed', params: { fail: 'ReadInfoError' } });
      }
    };
    this.ws.onGetUpdateStatus = data => {
      // console.log('onGetUpdateStatus ->',data);
      if (data.Status === 1000) {
        this.updateComponentStatus = data.UpdateStatus;
        this.$store.dispatch(
          'bikeConnect/setBikeUpdateStatus',
          this.updateComponentStatus
        );
        this.funcCheckUpdateStatus(this.updateComponentStatus);
      } else this.$router.push({ name: 'ConnectFailed', params: { fail: 'ReadInfoError' } });
    };
    this.ws.onGetFrameNumber = data => {
      // console.log("onGetFrameNumber",data)
      if (data.Status === 1000) {
        this.frameNo = data['Frame number'];
        this.$store.dispatch('bikeConnect/setBikeFrameNo', this.frameNo);
        // 比對Type 有五種情形
        // 輸入CSL PN DISP PN DRV PN MID FrameNo
        this.funcCheckPN_API();
      } else {
        this.$router.push({ name: 'ConnectFailed', params: { fail: 'ReadInfoError' } });
      }
    };
    this.ws.onWriteMid = data => {
      if (data.Status === 1000) {
        switch (this.getNewMIDType) {
          case 'C':
            this.requestData.ConsoleMID = this.NewMID;
            break;
          case 'D':
            this.requestData.DriverMID = this.NewMID;
            break;
          case 'P':
            this.requestData.DisplayMID = this.NewMID;
            break;
        }
        this.$store.dispatch('bikeConnect/getDeviceInfo', this.requestData);
        if (!this.funcCheckNeedToGetNewMID()) {
          this.ws.GetFrameNumber();
        }
      } else {
        this.$router.push({ name: 'ConnectFailed', params: { fail: 'WriteInfoError' } });
      }
    };
    this.ws.onGetSystemInfo = data => {
      if (data.Status === 1000) {
        // console.log('onGetSystemInfo', data)
        this.pageLoading = false;
        this.funcBindBikeModel();
        this.$store.dispatch('bikeInformation/addBikeSystemInfo', data);
        this.$router.push('/service-tools/bike-overview');
      } else {
        this.$router.push({ name: 'ConnectFailed', params: { fail: 'ReadInfoError' } });
      }
    };
    this.ws.onChangeBike = data => {
      if (data.Status === 1000) {
        this.$store.dispatch('bikeConnect/setBikeFlag', false);
        this.$store.dispatch('bikeConnect/getMGopen', false);
        this.ws.CheckComport();
      }
    };
  },
  beforeDestroy () {
    this.destroyFlag = true;
    this.ws.disconnect();
    // console.log('connect page over')
  }
};

export const bikeRecheckVINAPI = {
  data () {
    return {
      ws: '',
      timeInterval: null,
      destroyFlag: false
    };
  },
  mounted () {
    this.websocketConnect();
  },
  methods: {
    websocketConnect () {
      const wsUrl = 'ws://127.0.0.1:58000/';
      const apiCustomer = 'BR';
      const apiKey =
        '30f239bf561b7e33b94bf6370926341c83efa84102be92027601a74a2ae1160b';
      this.ws = new WebSocketWrapper(wsUrl, apiCustomer, apiKey);

      /**
       * connect 連結websocket，建立通道
       */
      this.ws.connect();

      this.ws.onConnected = data => {
        this.ws.CheckComport();
      };

      this.ws.onDisconnected = data => {
        // const strError = 'Please open message gateway'
        // this.$router.push('/connect/failed')
        this.$store.dispatch('bikeConnect/getMGopen', true);
        if (!this.destroyFlag) {
          this.errMsgDialog({
            disconnectMG: true,
            show: true
          });
        }
      };

      /**
       * CheckComponrt 檢查是否接上Dongle
       */
      this.ws.onCheckComport = data => {
        if (data.Status === 1000) {
          this.funcTimeInterval();
        } else {
          this.$router.push({ name: 'ConnectFailed', params: { fail: 'ComportError' } });
        }
      };

      this.ws.onWriteBikeId = data => {
        // console.log('onWriteBikeId', data)
        if (data.Status === 1000) {
          this.$store.dispatch('bikeConnect/setBikeId', this.NewBikeID);
          this.ws.GetSystemInfo();
        } else this.$router.push({ name: 'ConnectFailed', params: { fail: 'WriteInfoError' } });
      };

      this.ws.onWriteFrameNo = data => {
        console.log('onWriteFrameNo', data);
        if (data.Status === 1000) {
          this.funcWriteBikeId_API();
        } else {
          this.$router.push({ name: 'ConnectFailed', params: { fail: 'WriteInfoError' } });
        }
      };
      this.ws.onGetSystemInfo = data => {
        if (data.Status === 1000) {
          // console.log('onGetSystemInfo', data)
          this.funcBindBikeModel();
          this.$store.dispatch('bikeInformation/addBikeSystemInfo', data);
          this.$router.push('/service-tools/bike-overview');
        } else {
          this.$router.push({ name: 'ConnectFailed', params: { fail: 'ReadInfoError' } });
        }
      };

      // 監聽 keep connect
      this.ws.onCheckConnectStatus = data => {
        if (data.Status === 1001) {
          this.$router.push({ name: 'ConnectFailed', params: { fail: 'ComportError' } });
        }
      };
    },
    funcKeepConnect () {
      this.ws.CheckConnectStatus();
    },
    funcTimeInterval () {
      clearInterval(this.timeInterval);
      this.funcKeepConnect();
      this.timeInterval = setInterval(() => {
        this.funcKeepConnect();
      }, 3000);
    }
  },
  beforeDestroy () {
    this.destroyFlag = true;
    this.ws.disconnect();
    clearInterval(this.timeInterval);
    // console.log('connect page over')
  }
};

export const websocketAPI = {
  data () {
    return {
      ws: '',
      seconds: '',
      timeInterval: null,
      destroyFlag: false
    };
  },
  mounted () {
    const wsUrl = 'ws://127.0.0.1:58000/';
    const apiCustomer = 'BR';
    const apiKey =
      '30f239bf561b7e33b94bf6370926341c83efa84102be92027601a74a2ae1160b';
    this.ws = new WebSocketWrapper(wsUrl, apiCustomer, apiKey);

    this.ws.connect();

    this.ws.onDisconnected = data => {
      // console.log('onDisconnected')
      this.$store.dispatch('bikeConnect/getMGopen', true);
      if (!this.destroyFlag) {
        this.boolDisconnect = true;
        this.errMsgDialog({
          disconnectMG: true,
          show: true
        });
      }
      // 未開EXE
      // this.$router.push('/connect/failed')
    };

    this.ws.onError = data => {
      // console.log('ws的onError')
      // console.log('TCL: mounted -> data', data)
      // Error code 20001-20010
    };
  },
  beforeDestroy () {
    this.destroyFlag = true;
    this.ws.StopListenBtn();
    this.ws.disconnect();
    clearInterval(this.timeInterval);
    // console.log('change page close keep connect')
  },
  methods: {
    funcKeepConnect () {
      this.ws.CheckConnectStatus();
    },
    funcTimeInterval () {
      clearInterval(this.timeInterval);
      this.timeInterval = setInterval(this.funcKeepConnect, 3000);
      // console.log('call keep connect => wsApi funcTimeInterval')
      // this.timeInterval = setInterval(() => {
      //   this.ws.CheckConnectStatus()
      //   // console.log('call keep connect => wsApi funcTimeInterval')
      // }, 2000)
    }
    //   funcTimeInterval () {
    //     this.timeInterval = setInterval(() => {
    //       this.ws.CheckConnectStatus()
    //     }, 5000)
    //   }
  }
};

export const bikeOverviewAPI = {
  mounted () {
    this.ws.onConnected = data => {
      this.ws.ResetDisplayAstLevel();
    };
    this.ws.onResetDisplayAstLevel = data => {
      if (data.Status === 1000) {
        console.log('onResetDisplayAstLevel:', data)
        this.ws.GetHistoryErrorCode();
      } else {
        console.error('resetDisplay', data);
        this.boolDisconnect = true;
        this.modal.data.title = this.$t('disconnect.modalTitle');
        this.modal.data.content = this.$t('connectFailed.failedMsg.writeInfoError');
        this.modalOpen = true;
      }
    }
    this.ws.onGetHistoryErrorCode = data => {
      if (data.Status === 1000) {
        this.funcBindBikeErrorCode(data);
        this.ws.GetBikeInfo();
      } else {
        this.boolDisconnect = true;
        this.modal.data.title = this.$t('disconnect.modalTitle');
        this.modal.data.content = this.$t('connectFailed.failedMsg.readInfoError');
        this.modalOpen = true;
      }
    };
    this.ws.onGetBikeInfo = data => {
      if (data.Status === 1000) {
        this.funcBindBikeInfo(data);
        this.funcBindBikeSupport(data);
        this.ws.GetBatteryInfo();
      } else {
        this.boolDisconnect = true;
        this.modal.data.title = this.$t('disconnect.modalTitle');
        this.modal.data.content = this.$t('connectFailed.failedMsg.readInfoError');
        this.modalOpen = true;
      }
    };
    this.ws.onGetBatteryInfo = data => {
      if (data.Status === 1000) {
        this.funcBindBikeBattery(data);
        this.ws.GetSystemConfig();
      } else {
        this.boolDisconnect = true;
        this.modal.data.title = this.$t('disconnect.modalTitle');
        this.modal.data.content = this.$t('connectFailed.failedMsg.readInfoError');
        this.modalOpen = true;
      }
    };
    this.ws.onGetConsoleBtns = function (e) {};
    this.ws.onSystemConfig = data => {
      if (data.Status === 1000) {
        this.funcBindSmartParts(data);
        this.funcGetBikeLatestFW(this.getBikeSystemInfo);
        this.funcTimeInterval();
      } else {
        this.boolDisconnect = true;
        this.modal.data.title = this.$t('disconnect.modalTitle');
        this.modal.data.content = this.$t('connectFailed.failedMsg.readInfoError');
        this.modalOpen = true;
      }
    };

    // 監聽 keep connect
    this.ws.onCheckConnectStatus = data => {
      if (data.Status === 1001) {
        this.boolDisconnect = true;
        this.modal.data.title = this.$t('disconnect.modalTitle');
        this.modal.data.content = `[${data.ErrorCode}] ${this.$t(
          'errorCodeMsg.' + data.ErrorCode
        )}`;
        this.modalOpen = true;
      }
    };
  }
};

export const diagnosisAPI = {
  mounted () {
    this.ws.onConnected = data => {
      this.funcTimeInterval();
      this.ws.StartListenBtn();
    };
    this.ws.onStartListenBtn = data => {
      if (data.Status === 1401) this.ws.StartListenBtn();
    };
    // hmi: button checking
    this.ws.onDiagnosisConsoleBtns = data => {
      // // console.log('onDiagnosisConsoleBtns', data)
      if (data.Status === 1001) {
        this.bikeVal = data.Status;
        this.bikeErrorCode = data;
      } else if (data.Status === 1300) this.seconds = data.Message;
      else if (data.Status === 1301) {
        this.bikeVal = data.Message;
        this.seconds = 0;
      }
      // 當Dongle被拔掉
      if (
        data.ErrorCode === 30001 ||
        data.ErrorCode === 30002 ||
        data.ErrorCode === 30003
      ) {
        this.boolDisconnect = true;
        this.errMsgDialog({
          title: this.$t('disconnect.modalTitle'),
          show: true,
          errCode: data.ErrorCode,
          btnOk: this.$t('disconnect.modalBtnOk')
        });
      }
    };
    // hmi: flash
    this.ws.onDiagnosisDisplayFlash = data => {
      // // console.log('onDiagnosisDisplayFlash', data)
      // 特別處理 需要用肉眼判斷
      if (data.Status === 1001) {
        // this.bikeVal = data.Status
        this.bikeErrorCode = data.ErrorCode;
        // 用肉眼判斷對或錯就要停止 *
        // this.ws.DiagnosisDisplayTestStop()
      } else if (data.Status === 1000) {
        // this.bikeVal = data.Message
        this.bikeVal = data.Status;
        // this.ws.DiagnosisDisplayTestStop()
      } else this.bikeVal = data.Status;

      // 當Dongle被拔掉
      if (
        data.ErrorCode === 30001 ||
        data.ErrorCode === 30002 ||
        data.ErrorCode === 30003
      ) {
        this.boolDisconnect = true;
        this.errMsgDialog({
          title: this.$t('disconnect.modalTitle'),
          show: true,
          errCode: data.ErrorCode,
          btnOk: this.$t('disconnect.modalBtnOk')
        });
      }
    };
    // Driver
    this.ws.onDiagnosisController = data => {
      // // console.log('onDiagnosisController', data)
      // 當Dongle被拔掉
      if (data.Status === 1001) this.bikeErrorCode = data;
      // 檢測斷線的時候不需要再秀斷線Dialog
      // if (
      //   data.ErrorCode === 30001 ||
      //   data.ErrorCode === 30002 ||
      //   data.ErrorCode === 30003
      // ) {
      //   this.boolDisconnect = true
      //   this.errMsgDialog({
      //     title: this.$t('disconnect.modalTitle'),
      //     show: true,
      //     errCode: data.ErrorCode,
      //     btnOk: this.$t('disconnect.modalBtnOk')
      //   })
      // }
      if (data.Status === 1300) this.seconds = data.Message;
      this.bikeStatus = data.Status;
    };
    // motor
    this.ws.onDiagnosisMotor = data => {
      if (data.Status === 1001) this.bikeErrorCode = data;
      // 檢測斷線的時候不需要再秀斷線Dialog
      // if (
      //   data.ErrorCode === 30001 ||
      //   data.ErrorCode === 30002 ||
      //   data.ErrorCode === 30003
      // ) {
      //   this.boolDisconnect = true
      //   this.errMsgDialog({
      //     title: this.$t('disconnect.modalTitle'),
      //     show: true,
      //     errCode: data.ErrorCode,
      //     btnOk: this.$t('disconnect.modalBtnOk')
      //   })
      // }
      // console.log("TCL: mounted -> this.bikeStatus", this.bikeStatus)
      if (data.Status === 1300) this.seconds = data.Message;
      this.bikeStatus = data.Status;
    };
    // battery
    this.ws.onDiagnosisBattery = data => {
      // // console.log('onDiagnosisBattery', data)
      // 當Dongle被拔掉
      if (data.Status === 1001) this.bikeErrorCode = data;
      // 檢測斷線的時候不需要再秀斷線Dialog
      // if (
      //   data.ErrorCode === 30001 ||
      //   data.ErrorCode === 30002 ||
      //   data.ErrorCode === 30003
      // ) {
      //   this.boolDisconnect = true
      //   this.errMsgDialog({
      //     title: this.$t('disconnect.modalTitle'),
      //     show: true,
      //     errCode: data.ErrorCode,
      //     btnOk: this.$t('disconnect.modalBtnOk')
      //   })
      // }
      if (data.Status === 1300) this.seconds = data.Message;
      this.bikeStatus = data.Status;
    };
    // speed sensor
    this.ws.onDiagnosisSpeedSensor = data => {
      // // console.log('onDiagnosisSpeedSensor', data)
      if (data.Status === 1300) this.seconds = data.Message;
      if (data.Status === 1304) this.bikeVal = data.Message;
      if (data.Status === 1001) this.bikeErrorCode = data;
      // 當Dongle被拔掉
      if (
        data.ErrorCode === 30001 ||
        data.ErrorCode === 30002 ||
        data.ErrorCode === 30003
      ) {
        this.boolDisconnect = true;
        this.errMsgDialog({
          title: this.$t('disconnect.modalTitle'),
          show: true,
          errCode: data.ErrorCode,
          btnOk: this.$t('disconnect.modalBtnOk')
        });
      }

      this.bikeStatus = data.Status;
    };
    // torque sensor
    this.ws.onDiagnosisTorqueSensor = data => {
      // // console.log('onDiagnosisTorqueSensor', data)
      if (data.Status === 1300) this.seconds = data.Message;
      if (data.Status === 1304) this.bikeVal = data.Message;
      if (data.Status === 1001) this.bikeErrorCode = data;
      // 當Dongle被拔掉
      if (
        data.ErrorCode === 30001 ||
        data.ErrorCode === 30002 ||
        data.ErrorCode === 30003
      ) {
        this.boolDisconnect = true;
        this.errMsgDialog({
          title: this.$t('disconnect.modalTitle'),
          show: true,
          errCode: data.ErrorCode,
          btnOk: this.$t('disconnect.modalBtnOk')
        });
      }

      this.bikeStatus = data.Status;
    };
    // cadence sensor
    this.ws.onDiagnosisCadenceSensor = data => {
      // // console.log('onDiagnosisCadenceSensor', data)
      if (data.Status === 1300) this.seconds = data.Message;
      if (data.Status === 1304) this.bikeVal = data.Message;
      if (data.Status === 1001) this.bikeErrorCode = data;
      // 當Dongle被拔掉
      if (
        data.ErrorCode === 30001 ||
        data.ErrorCode === 30002 ||
        data.ErrorCode === 30003
      ) {
        this.boolDisconnect = true;
        this.errMsgDialog({
          title: this.$t('disconnect.modalTitle'),
          show: true,
          errCode: data.ErrorCode,
          btnOk: this.$t('disconnect.modalBtnOk')
        });
      }

      this.bikeStatus = data.Status;
    };
    // 監聽 keep connect
    this.ws.onCheckConnectStatus = data => {
      if (data.Status === 1001) {
        this.boolDisconnect = true;
        this.errMsgDialog({
          title: this.$t('disconnect.modalTitle'),
          show: true,
          errCode: data.ErrorCode,
          btnOk: this.$t('disconnect.modalBtnOk')
        });
      }
    };
  }
};

export const updateAPI = {
  data () {
    return {
      nowUpdatedComponent: { PartType: '' },
      hideFooter: false,
      updateStatus: {
        count: 0,
        retryCount: 2
      }
    };
  },
  mounted () {
    this.ws.onConnected = data => {
      this.funcTimeInterval();
    };
    this.ws.onCheckComport = data => {
      switch (this.nowUpdatedComponent.PartType) {
        case 'C':
          this.ws.UpgradeConsole(
            this.objPartFWData.FWData,
            this.objPartFWData.FWChecksum
          );
          // console.log("更新失敗,C",this.objPartFWData.FWData, this.objPartFWData.FWChecksum )
          break;
        case 'D':
          this.ws.UpgradeDriver(
            this.objPartFWData.FWData,
            this.objPartFWData.FWChecksum
          );
          // console.log("更新失敗,D",this.objPartFWData.FWData, this.objPartFWData.FWChecksum )
          break;
        case 'M':
          this.ws.UpgradeBroseDrive(
            this.objPartFWData.FWData,
            this.objPartFWData.FWChecksum,
            this.objPartFWData.FWParametersData,
            this.objPartFWData.FWParametersChecksum
          );
          // console.log("更新失敗,M",this.objPartFWData.FWData, this.objPartFWData.FWChecksum,this.objPartFWData.FWParametersData, this.objPartFWData.FWParametersChecksum)
          break;
        case 'P':
          this.ws.UpgradeDisplay(
            this.objPartFWData.FWData,
            this.objPartFWData.FWChecksum
          );
          // console.log("更新失敗,P",this.objPartFWData.FWData, this.objPartFWData.FWChecksum )
          break;
        default:
        // console.log('No update')
      }
    };
    this.ws.onCheckPower = data => {
      if (data.Status === 1001) {
        this.hideFooter = true;
        let errorCode = '30002-1';
        this.errMsgDialog({
          title: this.$t('disconnect.modalTitle'),
          show: true,
          errCode: errorCode,
          btnOk: this.$t('disconnect.modalBtnOk')
        });
        this.ws.CheckPower();
      } else {
        this.funcTimeInterval();
        this.modalOpenDisconnect = false;
        this.hideFooter = false;
      }
    };
    this.ws.onUpgradeConsole = data => {
      this.nowUpdatedComponent = { PartType: 'C', CompletedUpdate: false };
      this.objUpdatedMsg = data;
      // 未完成
      if (data.Status === 1000) {
        this.nowUpdatedComponent = { PartType: 'C', CompletedUpdate: true };
        const Type = this.objUpdatedVer.Type; // C
        const LatestFW = this.objUpdatedVer.LatestFW; // A04
        // 修改store bikeSystemInfo 的data
        this.$store.dispatch('bikeInformation/updateBikeSystemInfo', {
          Type,
          LatestFW
        });
        this.ws.CheckPower();
      } else if (data.Status === 1001) {
        this.$store.dispatch('bikeConnect/setBikeFlag', true);
        if (data.ErrorCode === 30001) {
          // 更新的時候拔掉dongle, 持續確認dongle 是否接上，若是接上則繼續更新
          this.nowUpdatedComponent = { PartType: 'C', CompletedUpdate: false };
          this.ws.CheckComport();
        }

        if (this.updateStatus.count < this.updateStatus.retryCount) {
          this.updateStatus.count++;
          this.ws.UpgradeConsole(this.objPartFWData.FWData, this.objPartFWData.FWChecksum);
        }
      }
    };
    this.ws.onUpgradeDisplay = data => {
      this.nowUpdatedComponent = { PartType: 'P', CompletedUpdate: false };
      this.objUpdatedMsg = data;
      // 未完成
      if (data.Status === 1000) {
        this.nowUpdatedComponent = { PartType: 'P', CompletedUpdate: true };
        const Type = this.objUpdatedVer.Type; // C
        const LatestFW = this.objUpdatedVer.LatestFW; // A04
        // 修改store bikeSystemInfo 的data
        this.$store.dispatch('bikeInformation/updateBikeSystemInfo', {
          Type,
          LatestFW
        });
      } else if (data.Status === 1001) {
        this.$store.dispatch('bikeConnect/setBikeFlag', true);
        if (data.ErrorCode === 30001) {
          // 更新的時候拔掉dongle, 持續確認dongle 是否接上，若是接上則繼續更新
          this.nowUpdatedComponent = { PartType: 'P', CompletedUpdate: false };
          this.ws.CheckComport();
        }

        if (this.updateStatus.count < this.updateStatus.retryCount) {
          this.updateStatus.count++;
          this.ws.UpgradeDisplay(this.objPartFWData.FWData, this.objPartFWData.FWChecksum);
        }
      }
    };
    this.ws.onUpgradeDriver = data => {
      this.nowUpdatedComponent = { PartType: 'D', CompletedUpdate: false };
      this.objUpdatedMsg = data;
      // 未完成
      if (data.Status === 1000) {
        this.nowUpdatedComponent = { PartType: 'D', CompletedUpdate: true };
        const Type = this.objUpdatedVer.Type; // C
        const LatestFW = this.objUpdatedVer.LatestFW; // A04
        // 修改store bikeSystemInfo 的data
        this.$store.dispatch('bikeInformation/updateBikeSystemInfo', {
          Type,
          LatestFW
        });
      } else if (data.Status === 1001) {
        this.$store.dispatch('bikeConnect/setBikeFlag', true);
        if (data.ErrorCode === 30001) {
          // 更新的時候拔掉dongle, 持續確認dongle 是否接上，若是接上則繼續更新
          this.nowUpdatedComponent = { PartType: 'D', CompletedUpdate: false };
          this.ws.CheckComport();
        }

        if (this.updateStatus.count < this.updateStatus.retryCount) {
          this.updateStatus.count++;
          this.ws.UpgradeDriver(this.objPartFWData.FWData, this.objPartFWData.FWChecksum);
        }
      }
    };
    this.ws.onUpgradeBroseDrive = data => {
      this.nowUpdatedComponent = { PartType: 'M', CompletedUpdate: false };
      this.objUpdatedMsg = data;
      // 未完成
      if (data.Status === 1000) {
        this.nowUpdatedComponent = { PartType: 'M', CompletedUpdate: true };
        const Type = this.objUpdatedVer.Type; // C
        const LatestFW = this.objUpdatedVer.LatestFW; // A04
        // 修改store bikeSystemInfo 的data
        this.$store.dispatch('bikeInformation/updateBikeSystemInfo', {
          Type,
          LatestFW
        });
      } else if (data.Status === 1001) {
        this.$store.dispatch('bikeConnect/setBikeFlag', true);
        if (data.ErrorCode === 30001) {
          // 更新的時候拔掉dongle, 持續確認dongle 是否接上，若是接上則繼續更新
          this.nowUpdatedComponent = { PartType: 'M', CompletedUpdate: false };
          this.ws.CheckComport();
        }

        if (this.updateStatus.count < this.updateStatus.retryCount) {
          this.updateStatus.count++;
          this.ws.UpgradeBroseDrive(this.objPartFWData.FWData, this.objPartFWData.FWChecksum, this.objPartFWData.FWParametersData, this.objPartFWData.FWParametersChecksum);
        }
      }
    };
    // 監聽 keep connect
    this.ws.onCheckConnectStatus = data => {
      if (data.Status === 1001) {
        this.boolDisconnect = true;
        this.errMsgDialog({
          title: this.$t('disconnect.modalTitle'),
          show: true,
          errCode: data.ErrorCode,
          btnOk: this.$t('disconnect.modalBtnOk')
        });
      }
    };
  }
};

export const settingAPI = {
  mounted () {
    this.ws.onConnected = data => {
      this.ws.CheckComport();
    };
    this.ws.onCheckComport = data => {
      if (data.Status === 1000) {
        this.ws.CheckPower();
      } else {
        this.ws.CheckComport();
      }
    };
    this.ws.onCheckPower = data => {
      if (this.restoreFlag) {
        this.ws.ReadPara();
        return;
      }
      if (data.Status === 1000) {
        this.funcGetCommonCustomizenInfo();
      } else {
        let title = 'Warning';
        let message = this.$t('connectBike.pleaseConnectYourBike');
        this.funcOpenDialog(
          title,
          message,
          this.funcCloseDialog,
          this.funcCloseDialog
        );
      }
    };
    this.ws.onGetBikeInfo = data => {
      this.funcTimeInterval();
      // console.log('call keep connect => wsApi settingAPI onGetBikeInfo call connect')
      this.isLoading = false;
      if (data.Status === 1000) {
        this.$store.dispatch('bikeInformation/addBikeInfoList', data);
        let title = 'Message';
        let message = this.$t('setting.msg.setSuccess');
        this.funcApplyData();
        this.funcOpenDialog(
          title,
          message,
          this.funcCloseDialog,
          this.funcCloseDialog
        );
      } else {
        let title = 'Message';
        let message = this.$t('setting.msg.setFail');
        this.funcOpenDialog(
          title,
          message,
          this.funcCloseDialog,
          this.funcCloseDialog
        );
      }
    };
    this.ws.onGetCommonCustomizenInfo = data => {
      /**
       * errorcode 39010 [設定參數讀取錯誤]
       * 遇 39010 時帶入原讀取參數，讓使用者重新輸入，就可避免此錯誤
       */
      if (data.Status === 1000 || data.ErrorCode === 39010) {
        // console.log('onGetCommonCustomizenInfo', data)
        this.funcBindCommonCustomizenInfo(data);
        this.funcGetSystemConfig();
      } else {
        this.isLoading = false;
        let title = 'Error';
        let message = 'Read data failure';
        this.funcOpenDialog(
          title,
          message,
          this.funcCloseDialog,
          this.funcCloseDialog
        );
      }
    };
    this.ws.onSystemConfig = data => {
      this.funcTimeInterval();
      // console.log('call keep connect => wsApi settingAPI onSystemConfig call connect')
      this.isLoading = false;
      if (data.Status === 1000) {
        // console.log('onSystemConfig', data)
        this.funcBindSystemConfig(data);
        this.funcCheckIsHaveDriver();
      } else {
        let title = 'Error';
        let message = 'Read data failure';
        this.funcOpenDialog(
          title,
          message,
          this.funcCloseDialog,
          this.funcCloseDialog
        );
      }
    };
    this.ws.onWriteMaintenanceWarning = data => {
      // console.log('onWriteMaintenanceWarning', data)
      if (data.Status === 1000) {
        if (this.funcCheckIsFinalStep()) return;
        this.funcCheckNowStep();
      } else {
        this.settingStepCount = 0;
        this.isLoading = false;
        let title = 'Error';
        let message = this.$t('setting.msg.setFail');
        this.funcOpenDialog(
          title,
          message,
          this.funcCloseDialog,
          this.funcCloseDialog
        );
      }
    };
    this.ws.onWriteNextMaintenanceODO = data => {
      // console.log('onWriteNextMaintenanceODO', data)
      if (data.Status === 1000) {
        if (this.funcCheckIsFinalStep()) return;
        this.funcCheckNowStep();
      } else {
        this.settingStepCount = 0;
        this.isLoading = false;
        let title = 'Error';
        let message = this.$t('setting.msg.setFail');
        this.funcOpenDialog(
          title,
          message,
          this.funcCloseDialog,
          this.funcCloseDialog
        );
      }
    };
    this.ws.onWriteEnergyBar = data => {
      // console.log('onWriteEnergyBar', data)
      if (data.Status === 1000) {
        if (this.funcCheckIsFinalStep()) return;
        this.funcCheckNowStep();
      } else {
        this.settingStepCount = 0;
        this.isLoading = false;
        let title = 'Error';
        let message = this.$t('setting.msg.setFail');
        this.funcOpenDialog(
          title,
          message,
          this.funcCloseDialog,
          this.funcCloseDialog
        );
      }
    };
    this.ws.onWriteStartUpLightON = data => {
      // console.log('onWriteStartUpLightON', data)
      if (data.Status === 1000) {
        if (this.funcCheckIsFinalStep()) return;
        this.funcCheckNowStep();
      } else {
        this.settingStepCount = 0;
        this.isLoading = false;
        let title = 'Error';
        let message = this.$t('setting.msg.setFail');
        this.funcOpenDialog(
          title,
          message,
          this.funcCloseDialog,
          this.funcCloseDialog
        );
      }
    };
    this.ws.onWriteSpeedUnits = data => {
      // console.log('onWriteSpeedUnits', data)
      if (data.Status === 1000) {
        if (this.funcCheckIsFinalStep()) return;
        this.funcCheckNowStep();
      } else {
        this.settingStepCount = 0;
        this.isLoading = false;
        let title = 'Error';
        let message = this.$t('setting.msg.setFail');
        this.funcOpenDialog(
          title,
          message,
          this.funcCloseDialog,
          this.funcCloseDialog
        );
      }
    };
    this.ws.onWriteParameters = data => {
      if (data.Status === 1000) {
        if (this.funcCheckIsFinalStep()) return;
        this.funcCheckNowStep();
      } else {
        this.settingStepCount = 0;
        this.isLoading = false;
        let title = 'Error';
        let message = this.$t('setting.msg.setFail');
        this.funcOpenDialog(
          title,
          message,
          this.funcCloseDialog,
          this.funcCloseDialog
        );
      }
    };
    this.ws.onWriteStartUpPowerLevel = data => {
      // console.log('onWriteStartUpPowerLevel', data)
      if (data.Status === 1000) {
        if (this.funcCheckIsFinalStep()) return;
        this.funcCheckNowStep();
      } else {
        this.settingStepCount = 0;
        this.isLoading = false;
        let title = 'Error';
        let message = this.$t('setting.msg.setFail');
        this.funcOpenDialog(
          title,
          message,
          this.funcCloseDialog,
          this.funcCloseDialog
        );
      }
    };
    this.ws.onWriteWheelSize = data => {
      // console.log('onWriteWheelSize', data)
      if (data.Status === 1000) {
        if (this.funcCheckIsFinalStep()) return;
        this.funcCheckNowStep();
      } else {
        this.settingStepCount = 0;
        // console.log('onWriteWheelSize error')
        this.isLoading = false;
        let title = 'Error';
        let message = this.$t('setting.msg.setFail');
        this.funcOpenDialog(
          title,
          message,
          this.funcCloseDialog,
          this.funcCloseDialog
        );
      }
    };
    this.ws.onWritePowerLevels = data => {
      // console.log('onWritePowerLevels', data)
      if (data.Status === 1000) {
        this.functionPowerLvCacheUpdate();
        if (this.funcCheckIsFinalStep()) return;
        this.funcCheckNowStep();
      } else {
        this.settingStepCount = 0;
        // console.log('onWritePowerLevels error')
        this.isLoading = false;
        let title = 'Error';
        let message = this.$t('setting.msg.setFail');
        this.funcOpenDialog(
          title,
          message,
          this.funcCloseDialog,
          this.funcCloseDialog
        );
      }
    };
    this.ws.onWriteAutoSleep = data => {
      // console.log('onWriteAutoSleep', data)
      if (data.Status === 1000) {
        if (this.funcCheckIsFinalStep()) return;
        this.funcCheckNowStep();
      } else {
        this.settingStepCount = 0;
        // console.log('onWriteAutoSleep error')
        this.isLoading = false;
        let title = 'Error';
        let message = this.$t('setting.msg.setFail');
        this.funcOpenDialog(
          title,
          message,
          this.funcCloseDialog,
          this.funcCloseDialog
        );
      }
    };
    this.ws.onWriteTorqueResponse = data => {
      // console.log('onWriteTorqueResponse', data)
      if (data.Status === 1000) {
        if (this.funcCheckIsFinalStep()) return;
        this.funcCheckNowStep();
      } else {
        this.settingStepCount = 0;
        // console.log('onWriteTorqueResponse error')
        this.isLoading = false;
        let title = 'Error';
        let message = this.$t('setting.msg.setFail');
        this.funcOpenDialog(
          title,
          message,
          this.funcCloseDialog,
          this.funcCloseDialog
        );
      }
    };
    this.ws.onReadModePowerLevel = data => {
      // console.log('onReadModePowerLevel', data)
      if (data.Status === 1000) {
        this.inputRangeVal.powerlevelAdjust = data.PowerLV;
      } else {
        this.settingStepCount = 0;
        // console.log('onReadModePowerLevel error')
        this.isLoading = false;
        let title = 'Error';
        let message = this.$t('setting.msg.readDataFail');
        this.funcOpenDialog(
          title,
          message,
          this.funcCloseDialog,
          this.funcCloseDialog
        );
      }
    };
    this.ws.onResetSetting = data => {
      if (data.Status === 1000) {
        this.ws.ChangeBike();
      } else {
        this.isLoading = false;
        let title = 'Error';
        let message = this.$t('setting.msg.restoreFail');
        this.funcOpenDialog(
          title,
          message,
          this.funcCloseDialog,
          this.funcCloseDialog
        );
      }
    };
    this.ws.onChangeBike = data => {
      if (data.Status === 1000) {
        this.ws.CheckPower();
      }
    };
    this.ws.onReadPara = data => {
      this.isLoading = false;
      this.restoreFlag = false;
      if (data.Status === 1000) {
        this.funcOpenDialog(
          'Message',
          this.$t('setting.msg.restoreSucccess'),
          this.funcCloseDialog,
          this.funcCloseDialog
        );
        this.funcGetCommonCustomizenInfo();
      } else {
        let title = 'Error';
        let message = this.$t('setting.msg.restoreFail');
        this.funcOpenDialog(
          title,
          message,
          this.funcCloseDialog,
          this.funcCloseDialog
        );
      }
    };
    // 監聽 keep connect
    this.ws.onCheckConnectStatus = data => {
      if (data.Status === 1001) {
        let title = 'Message';
        let message = this.$t('connectBike.pleaseConnectYourBike');
        this.funcOpenDialog(
          title,
          message,
          this.funcGoToConnect,
          this.funcCloseDialog
        );
      }
    };
  }
};
